export default {
    getManningVessels: state => {
        return state.enterpriseManningVessels;
    },
    getOnboardingCrews: state => {
        return state.enterpriseOnboardingCrews;
    },
    getAshoreCrews: state => {
        return state.enterpriseAshoreCrews;
    },
    getCrewsRoles: state => {
        return state.enterpriseCrewsRoles;
    },
    getManningVesselsAlerts: state => {
      return state.enterpriseManningVesselAlerts;
    },
    getCrewAlerts: state => {
      return state.enterpriseCrewsAlerts;
    },
    getCrewAlertSettings: state => {
      return state.enterpriseCrewAlertSettings;
    }
}
